import React, { JSX, useEffect, useState } from 'react'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import GoogleIcon from '@mui/icons-material/Google'
import { useTranslation } from 'react-i18next'

import TabMenu from './Tabs'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import makeStyles from '@mui/styles/makeStyles/makeStyles'
import { Theme } from '@mui/material'
import { SocialNetworkLicensePermissions } from '@professocial/professocialTypes'

export interface Tab {
  icon: JSX.Element
  name: NetworkType
  label: string
  disabled?: boolean
}

interface IProps {
  activeItem?: NetworkType
  tabs: NetworkType[]
  licensePermissions?: SocialNetworkLicensePermissions
  onChangeTab?: (key: NetworkType) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    width: '0.8em',
    verticalAlign: 'top',
    fill: theme.palette.info.main,
  },
}))

const NetworkContentTabs: React.FC<IProps> = (props) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const [tabs, setTabs] = useState<Tab[]>([])
  const [activeItem, setActiveItem] = useState<NetworkType>()

  useEffect(() => {
    const createTabs: Tab[] = []
    const filterTabs = props.tabs
    const defaultTabs = [NetworkType.Facebook, NetworkType.Instagram, NetworkType.GoogleMyBusiness]

    defaultTabs.map((defaultTab: NetworkType) => {
      let licenseDisabled = false
      let icon = <span style={{ paddingRight: '10px' }}><FacebookIcon className={classes.icon} /></span>
      if (defaultTab === NetworkType.Instagram) {
        icon = <span style={{ paddingRight: '10px' }}><InstagramIcon className={classes.icon} /></span>
      }
      if (defaultTab === NetworkType.GoogleMyBusiness) {
        icon = <span style={{ paddingRight: '10px' }}><GoogleIcon className={classes.icon} /></span>
      }

      if (defaultTab === NetworkType.Facebook && !props.licensePermissions?.facebook) {
        licenseDisabled = true
      }
      if (defaultTab === NetworkType.Instagram && !props.licensePermissions?.instagram) {
        licenseDisabled = true
      }
      if (defaultTab === NetworkType.GoogleMyBusiness && !props.licensePermissions?.googleMyBusiness) {
        licenseDisabled = true
      }

      createTabs.push({
        icon,
        name: defaultTab,
        label: t(`dashboard:${defaultTab}`),
        disabled: !filterTabs.includes(defaultTab) && licenseDisabled
      })
    })
    setTabs(createTabs)
    setActiveItem(props.activeItem ? props.activeItem : createTabs[0].name)
  }, [props.tabs, props.licensePermissions],
  )

  useEffect(() => {
    props.activeItem && setActiveItem(props.activeItem)
  }, [props.activeItem],
  )

  return (
    <TabMenu
      tabs={tabs}
      activeItem={activeItem}
      licensePermissions={props.licensePermissions}
      onChangeTab={(tab: NetworkType) => {
        props.onChangeTab && props.onChangeTab(tab)
      }}
    />
  )
}
export default NetworkContentTabs
